import React, { Component } from 'react';
import { connect } from 'react-redux';
import Navbar from '../../components/public/Navbar';
import SimpleSnackbar from "../../components/SimpleSnackbar";


class PublicLayout extends Component {
    render() {
        const { Component, route } = this.props
        return (
            <div className="public-section">
                <SimpleSnackbar />

                <Navbar route={route} />
                <main>
                    <Component route={route} /> 
                </main>
            </div>
        );
    }
}

function mapStateToProps(state, props) { return { user: state.user } }
function mapDispatchToProps(dispatch) { return { dispatch }; }

export default connect(
    mapStateToProps,
    {}
)(PublicLayout);


// WEBPACK FOOTER //
// ./src/template/public/index.js